import React, {Fragment} from 'react';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {Trans} from '@common/i18n/trans';
import { FormSwitch } from '@common/ui/forms/toggle/switch';

export function CrupdateLoanProductFields() {

  return (
    <Fragment>
      <FormTextField
        name="name"
        label={<Trans message="Loan Product Name" />}
        className="mb-20"
        required
      />
      <FormSwitch
        name="active"
        className="mb-20 pb-20 border-b"
      >
        <Trans message="Active" />
      </FormSwitch>
    </Fragment>
  );
}
